<template>
    <div
        v-if="selectedOrderStatusConfig.showShippingSummary || selectedOrderStatusConfig.showOrderSummary"
        class="os-overview"
    >
        <div
            v-if="selectedOrderStatusConfig.showShippingSummary"
            class="os-overview__container os-overview__container--shipping-summary"
        >
            <ShippingSummary />
        </div>
        <div
            v-if="selectedOrderStatusConfig.showOrderSummary"
            class="os-overview__container os-overview__container--order-summary"
        >
            <OrderSummary />
        </div>
    </div>
</template>

<script>
    import ShippingSummary from './components/ShippingSummary';
    import OrderSummary from './components/OrderSummary';
    import OrderStatusHeaderConfig from '@/models/OrderStatusHeaderConfig';

    export default {
        components: {
            ShippingSummary,
            OrderSummary,
        },

        data() {
            return {
                selectedOrderStatusConfig: {},
            };
        },

        props: {
            status: {
                type: String,
                required: true,
            },
        },

        methods: {
            setStatusConfig() {
                this.selectedOrderStatusConfig = OrderStatusHeaderConfig[this.status];
            },
        },
        
        computed: {},

        created() {
            this.setStatusConfig();
        },
    };
</script>

<style lang="scss" scoped>
    .os-overview {
        display: flex;
        flex-direction: column;
        align-self: center;
        flex: 1 0 auto;
        width: 100%;
        padding-top: 24px;
        border-top: 1px solid #B8C1CC;
        
        @media screen and (min-width: 1025px) {
            flex-direction: row;
            justify-content: space-between;
            padding-top: 32px;
        }

        &__container {

            @media screen and (min-width: 1025px) {
                width: calc(50% - 44px);
            }

            &--shipping-summary {
            }
            &--order-summary {
            }
        }
    }
</style>
